import React from 'react';
import MDBox from 'src/components/md/MDBox';

/**
 * Creates a tab label with optional loading spinner
 */
export function tabLabel(label: string, loading: boolean) {
  return (
    <MDBox display="flex" alignItems="center">
      {label}
      {loading && (
        <span className="fa fa-spinner fa-spin" style={{ marginLeft: '8px' }} />
      )}
    </MDBox>
  );
}
